/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/* eslint-disable import/prefer-default-export */

import { InsightTypeStrings } from 'enums/InsightType'
import { getDisplayText, getColor } from '../utils'
import { DashboardWidget } from '../../../../../features/widget/types'
import { InsightCount } from '../../../../../schemas/action/InsightCountSchema'
import { WordCloudWidgetsType } from '../../types'

export const getWordCloudData = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: WordCloudWidgetsType,
  emojiNameToDisplayMap: Record<string, string>
) => {
  // NI-2615: Prospero may return an InsightCount with `insights` omitted for
  // a (topic x category) pair (e.g. Sentiment emotion/behavior keywords with
  // no matching data in the window). The previous `.insights![0].dataset!`
  // non-null chain threw `Cannot read properties of undefined (reading '0')`
  // which surfaced verbatim through the outer ErrorBoundary in new dashboard
  // mode. Fall back to [] so the widget renders the friendly empty state.
  const dataset = widgetData.data[0]?.results?.[0]?.data?.insights?.[0]?.dataset ?? []

  return dataset
    .flatMap((result) =>
      (result.set ?? []).slice(0, widgetSetting.topN).map((item) => ({
        insight: {
          ...item,
          insightType: result.insightType ? (result.insightType as InsightTypeStrings) : undefined
        }
      }))
    )
    .filter(
      (item) => item.insight.value! >= ('minCount' in widgetSetting ? widgetSetting.minCount! : 0)
    )
    .map((item) => ({
      text: getDisplayText(item.insight.name!, widgetSetting.viewOption!, emojiNameToDisplayMap),
      value: item.insight.value!,
      color: getColor(widgetSetting.analysisType!, item.insight.insightType),
      custom: item.insight
    }))
}
